import React, { Component } from 'react'
import { Rect } from 'react-konva'
import { updateCursor } from 'helpers/media'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Zone extends Component {

    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
        this.onMouseOver = this.onMouseOver.bind(this)
    }

    static propTypes = {
        computeViewData: PropTypes.func.isRequired,
        scale: PropTypes.number.isRequired,
        zone: PropTypes.object.isRequired,
        selectCollaborativeIndexationZone: PropTypes.func.isRequired,
        isCollaborativeIndexationSelected: PropTypes.func.isRequired,
        isSelectable: PropTypes.bool.isRequired,
    }

    onClick(event)
    {
        if(! this.props.isSelectable)
        {
            return
        }

        this.props.selectCollaborativeIndexationZone(event)
    }

    onMouseOver(event)
    {
        let cursor = 'pointer'
        if(! this.props.isSelectable)
        {
            cursor = 'grab'
        }

        updateCursor(cursor)(event)
    }

    render()
    {
        const { computeViewData, scale, zone, isCollaborativeIndexationSelected } = this.props
        const { rotation, offset } = computeViewData()
        const scaledZone = zone.rect.scale(scale)
        const positionVector = scaledZone.position.convertToVector().rotate(rotation)

        return (
            <Rect
                offset={{
                    x: offset.x,
                    y: offset.y
                }}
                position={positionVector.convertToPosition()}
                rotation={rotation}
                width={scaledZone.width}
                height={scaledZone.height}
                stroke={isCollaborativeIndexationSelected(zone.uuid) ? '#61B9BF' : null }
                strokeWidth={3}
                fill={'rgba(97, 185, 191, 0.18)'}
                onMouseOver={this.onMouseOver}
                onClick={this.onClick}
                onTouchend={this.onClick}
            />
        )
    }
}

export default withTranslation()(Zone)
